<template>
	<vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" ref="notificationRef">
		<feather-icon
			icon="BellIcon"
			class="cursor-pointer mt-1 sm:mr-6 mr-2 "
			v-bind:class="[$store.state.notifications.unreadNotifications > 0 ? 'bell' : '']"
			:badge="$store.state.notifications.unreadNotifications > 9 ? '9+' : $store.state.notifications.unreadNotifications"
		></feather-icon>
		<vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">
			<div class="notification-top text-center p-5 bg-primary text-white">
				<h6 @click="markAllRead([])" class="cursor-pointer text-white text-right">Đánh dấu tất cả là đã đọc</h6>
				<!-- <p class="opacity-75">App Notifications</p> -->
			</div>

			<PerfectScrollbar ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings">
				<ul class="bordered-items vs-con-loading__container" id="block-notifications">
					<li v-for="ntf in fiveLatestNotifications" :key="ntf.index" class="flex justify-between px-4 py-4 notification cursor-pointer" @click="closeDropdown">
						<div class="flex items-start" @click="markReadItem(ntf)">
							<!-- <feather-icon icon="BellIcon" :svgClasses="[!ntf.is_read ? `text-${'primary'}` : `text-${'dark'}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon> -->
							<noti-icon :ntf="ntf" />
							<div class="mx-2">
								<span class="font-medium block notification-title" :class="[!ntf.is_read ? `text-${'primary'}` : `text-${'dark'}`]" v-html="ntf.title"></span>
								<small v-html="ntf.body"></small>
							</div>
						</div>
						<small class="mt-1 whitespace-no-wrap" :class="[!ntf.is_read ? `text-${'primary'}` : `text-${'dark'}`]">{{ ntf.created_at }}</small>
					</li>
				</ul>
			</PerfectScrollbar>
			<a :href="$helper.currentAppPath() + '/notifications'" @click="closeDropdown">
				<div
					class="checkout-footer
                            fixed
                            bottom-0
                            rounded-b-lg
                            text-primary
                            w-full
                            p-2
                            font-semibold
                            text-center
                            border
                            border-b-0
                            border-l-0
                            border-r-0
                            border-solid
                            d-theme-border-grey-light
                            cursor-pointer"
				>
					<span>Xem tất cả</span>
				</div>
			</a>
		</vs-dropdown-menu>
	</vs-dropdown>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	data() {
		return {
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			}
		};
	},
	created() {
		this.getFiveLatestNotifications();
		// TODO: subscribe socket to load new notifications
	},
	methods: {
		getFiveLatestNotifications() {
			this.$store.dispatch("notifications/fetchLatestNotifications", { limit: this.$store.state.notifications.limitLatest, page: 1 });
			this.$store.dispatch("notifications/fetchUnreadNotifications");
		},
		markAllRead(listIds) {
			this.$vs.loading({
				container: "#block-notifications",
				scale: 0.6
			});
			this.$store.dispatch("notifications/markAllReadNotifications", { listIds: listIds, page: 1 }).then(() => {
				this.$vs.loading.close("#block-notifications > .con-vs-loading");
			});
		},
		markReadItem(ntf) {
			if (!ntf.is_read) {
				// this.markAllRead([ntf.id]);
				this.$store.dispatch("notifications/onClickNotification", { notification: ntf });
			} else {
				this.$store.dispatch("notifications/redirectToDetailNotification", { notification: ntf });
			}
		},
		closeDropdown() {
			if (this.$refs.notificationRef && this.$refs.notificationRef.$el) {
				this.$refs.notificationRef.$el.click();
			}
		}
	},
	mounted() {
		if (this.sockets) {
			this.sockets.subscribe("sensors", data => {
				let item = data.data;
				if (item.notification) {
					this.getFiveLatestNotifications();
				}
			});
		}
	},
	beforeDestroy() {
		if (this.sockets) {
			this.sockets.unsubscribe("sensors");
		}
	},
	computed: {
		...mapGetters({
			getLatestNotificationList: "notifications/getLatestNotificationList"
		}),
		fiveLatestNotifications() {
			return this.getLatestNotificationList || [];
		}
	}
};
</script>

<style lang="scss">
@import "@/assets/scss/cbs/animations.scss";
</style>
